import classNames from 'classnames'
import React, { FC, Fragment, ReactNode } from 'react'

import { ContentRenderer, ContentRendererProps } from '../ContentRenderer'
import Logos from '../icons/Logos.svg'
import s from './CommonTemplateSidePanel.scss'
import { ContentItem, MediaLayout } from './types'

export type SidePanelProps = {
  content?: {
    items: ContentItem[]
    background: string
    color: string
    mediaLayout?: MediaLayout
  }[]
  activeIndex?: number
  className?: string
  dataHook?: string
  logos?: boolean
  children?: ReactNode
} & Pick<ContentRendererProps, 'textMaxWidth' | 'textAlign' | 'imageMarginBottom'>

export const CommonTemplateSidePanel: FC<SidePanelProps> = ({
  className,
  content,
  activeIndex = 0,
  logos = false,
  children,
  dataHook = '',
  textMaxWidth = 370,
  textAlign,
  imageMarginBottom,
}) => {
  const active = content?.[activeIndex]

  return (
    <div
      className={classNames(s.CommonTemplateSidePanel, className)}
      style={{ background: active?.background }}
      data-hook={dataHook}
    >
      {content?.map((c, index) => (
        <Fragment key={c.items.map(i => i.content).join('')}>
          <div
            className={classNames(s.CommonTemplateSidePanel__content, {
              [s['CommonTemplateSidePanel__content--hidden']]: index !== activeIndex,
              [s['CommonTemplateSidePanel__content--rightEdge']]: c.mediaLayout === 'right-edge',
            })}
          >
            <ContentRenderer
              items={c?.items}
              color={c?.color}
              textMaxWidth={textMaxWidth}
              textAlign={textAlign}
              imageMarginBottom={imageMarginBottom}
            />
            {logos && (
              <div>
                <Logos />
              </div>
            )}
          </div>
        </Fragment>
      ))}
      {children}
    </div>
  )
}
